<template>
  <div class="board-box">
    <div style="margin-bottom: 0.5rem">
      <p class="text-title">客户风控管理</p>
    </div>
    <div class="grid-8 mb-1">
      <div class="card padding-bg">
        <p class="text-small">逾期客户数</p>
        <p class="text-big-title">{{ riskDashboard.overdueCustomer || 0 }}<span v-html="imageByCompare(riskDashboard.overdueCustomer, riskDashboard.lastOverdueCustomer)"></span></p>
        <p class="text-small" style="font-size: 12px;">上月逾期客户数 {{ riskDashboard.lastOverdueCustomer || 0 }}</p>
      </div>
      <div class="card padding-bg">
        <p class="text-small">逾期金额（万元）</p>
        <p class="text-big-title">{{ formatThousandSeparator(riskDashboard.overdueAmount) }}<span v-html="imageByCompare(riskDashboard.overdueAmount, riskDashboard.lastOverdueAmount)"></span></p>
        <p class="text-small" style="font-size: 12px;">上月逾期金额 {{ formatThousandSeparator(riskDashboard.lastOverdueAmount) }}</p>
      </div>
      <div class="card padding-bg">
        <p class="text-small">逾期率</p>
        <p class="text-big-title">{{ riskDashboard.overdueRate }}<span v-html="imageByCompare(riskDashboard.overdueRate, riskDashboard.lastOverdueRate)"></span></p>
        <p class="text-small" style="font-size: 12px;">上月逾期率 {{ riskDashboard.lastOverdueRate }}</p>
      </div>
      <div class="card padding-bg">
        <p class="text-small">逾期60天以上金额环比</p>
        <p class="text-big-title">{{ riskDashboard.cdefPartRate }}<span v-html="imageByCompare(riskDashboard.cdefPartAmount, riskDashboard.lastCdefPartAmount)"></span></p>
        <!-- <p class="text-small">上月逾期客户数 434</p> -->
      </div>
      <div class="card padding-bg">
        <p class="text-small">有额度客户代码数</p>
        <p class="text-big-title">{{ formatThousandSeparator(riskDashboard.haveQuotaCustomer) }}</p>
        <!-- <p class="text-small">上月逾期客户数 434</p> -->
      </div>
      <div class="card padding-bg">
        <p class="text-small">固定额度（万元）</p>
        <p class="text-big-title">{{ formatThousandSeparator(riskDashboard.fixedQuota) }}</p>
        <!-- <p class="text-small">上月逾期客户数 434</p> -->
      </div>
      <div class="card padding-bg">
        <p class="text-small">实际授信系数</p>
        <p class="text-big-title">{{ riskDashboard.creditCoefficient }}<span v-html="imageByCompare(convertPercentageToNumber(riskDashboard.creditCoefficient), convertPercentageToNumber(riskDashboard.lastCreditCoefficient))"></span></p>
        <p class="text-small" style="font-size: 12px;">上月 {{ riskDashboard.lastCreditCoefficient }}</p>
      </div>
      <div class="card padding-bg">
        <p class="text-small">已使用固定额度占比</p>
        <p class="text-big-title">{{ riskDashboard.usedQuotaRate }}<span v-html="imageByCompare(convertPercentageToNumber(riskDashboard.usedQuotaRate), convertPercentageToNumber(riskDashboard.lastUsedQuotaRate))"></span></p>
        <p class="text-small" style="font-size: 12px;">上月 {{ riskDashboard.lastUsedQuotaRate }}</p>
      </div>
    </div>
    <div class="grid-3 mb-1">
      <div class="card mb-1" style="padding: 10px 0">
        <div class="board-top-label mx-12">
          <p class="text-subtitle">各逾期账龄的逾期金额分布</p>
          <p class="text-subtitle" style="color: #5B687D;">单位：万元</p>
        </div>
        <BoardPieChart height="230px" :data="overdueAmountTypeList" />
      </div>
      <div class="card mb-1" style="padding: 10px 0">
        <div class="board-top-label mx-12">
          <p class="text-subtitle">各管控方式可用主体数量分布</p>
        </div>
        <BoardPieChart height="230px" :data="creditControlTypeList" />
      </div>
      <div class="card mb-1" style="padding: 10px 0">
        <div class="board-top-label mx-12">
          <p class="text-subtitle">各固定额度规则类型分布情况</p>
          <p class="text-subtitle" style="color: #5B687D;">单位：万元</p>
        </div>
        <BoardPieChart height="230px" :showLabel="false" :data="fixedLimitRuleTypeList" />
      </div>
    </div>
    <div class="grid-2">
      <div class="card">
        <div class="board-top-label mx-12 pt-12">
          <p class="text-subtitle">客户逾期趋势</p>
          <div class="from-box">
            <a-date-picker
              v-model:value="yearOverdue"
              :allowClear="false"
              v-if="overdueRef.dateQueryType === 3"
              @change="fetchOverdue"
              picker="year"
            />
            <a-range-picker
              v-model:value="weakOverdue"
              :allowClear="false"
              v-if="overdueRef.dateQueryType === 2"
              picker="week"
              @change="fetchOverdue"
            />

            <a-date-picker
              v-model:value="dayOverdue"
              :allowClear="false"
              v-if="overdueRef.dateQueryType === 1"
              @change="fetchOverdue"
              picker="month"
            />

            <a-radio-group
              v-model:value="overdueRef.dateQueryType"
              style="margin-left: 20px"
              @change="fetchOverdue"
            >
              <a-radio-button :value="1">天</a-radio-button>
              <a-radio-button :value="2">周</a-radio-button>
              <a-radio-button :value="3">月</a-radio-button>
            </a-radio-group>

            <a-radio-group
              v-model:value="overdueRef.dataType"
              style="margin-left: 20px"
              @change="fetchOverdue"
            >
              <a-radio-button :value="1">逾期率</a-radio-button>
              <a-radio-button :value="2">逾期金额</a-radio-button>
            </a-radio-group>
          </div>
        </div>
        <BoardLineChart height="280px" :data="overdueList" :isPercentageY="overdueRef.dataType === 1" />
      </div>
      <div class="card">
        <div class="board-top-label mx-12 pt-12">
          <a-radio-group v-model:value="creditRef.dataType" @change="fetchCredit">
            <a-radio-button :value="0">实际授信系数</a-radio-button>
            <a-radio-button :value="1">已使用固定额度占比</a-radio-button>
          </a-radio-group>
          <div class="from-box">
            <a-date-picker
              v-model:value="yearCredit"
              :allowClear="false"
              v-if="creditRef.dateQueryType === 3"
              @change="fetchCredit"
              picker="year"
            />
            <a-range-picker
              v-model:value="weakCredit"
              :allowClear="false"
              v-if="creditRef.dateQueryType === 2"
              picker="week"
              @change="fetchCredit"
            />

            <a-date-picker
              v-model:value="dayCredit"
              :allowClear="false"
              v-if="creditRef.dateQueryType === 1"
              @change="fetchCredit"
              picker="month"
            />

            <a-radio-group
              v-model:value="creditRef.dateQueryType"
              style="margin-left: 20px"
              @change="fetchCredit"
            >
              <a-radio-button :value="1">天</a-radio-button>
              <a-radio-button :value="2">周</a-radio-button>
              <a-radio-button :value="3">月</a-radio-button>
            </a-radio-group>
          </div>
        </div>
          <BoardLineChart height="280px" :data="creditList" :isPercentageY="creditRef.dataType === 1"/>
        </div>
      </div>
    </div>
</template>

<script setup lang="ts">
import BoardPieChart from './componects/BoardPieChart.vue'
import BoardLineChart from './componects/BoardLineChart.vue'
import { ref, onMounted, toRef, watch, PropType } from 'vue'
import request from '@/utils/request'
import { AxiosResult } from '@/typings/common'
import formatThousandSeparator from '@/utils/format'
import dayjs, { Dayjs } from 'dayjs'

const props = defineProps({
  formState: {
    type: Object as PropType<Object>,
  }
})

const formState = toRef(props, 'formState')

watch(() => props.formState, (newValue) => {
  formState.value = newValue
  fetchData()
})

const riskDashboard = ref({})
const overdueAmountTypeList = ref([])
const creditControlTypeList = ref([])
const fixedLimitRuleTypeList = ref([])
const fetchData = () => {
  request.post<AxiosResult, AxiosResult>('/fbu/api/report/risk/dashboard', formState.value).then((res) => {
    riskDashboard.value = res.data
  })

  request.post<AxiosResult, AxiosResult>('/fbu/api/report/risk/overdueAmountType', formState.value).then((res) => {
    const { overdueAmountType } = res.data
    overdueAmountTypeList.value = [
      { name: '1-30天', value: overdueAmountType?.apartAmount || 0 },
      { name: '31-60天', value: overdueAmountType?.bpartAmount || 0 },
      { name: '61-90天', value: overdueAmountType?.cpartAmount || 0 },
      { name: '91-180天', value: overdueAmountType?.dpartAmount || 0 },
      { name: '181-360天', value: overdueAmountType?.epartAmount || 0 },
      { name: '360天以上', value: overdueAmountType?.fpartAmount || 0 }
    ]
  })

  request.post<AxiosResult, AxiosResult>('/fbu/api/report/risk/creditControlType', formState.value).then((res) => {
    const { creditControlType } = res.data
    creditControlTypeList.value = [
      { name: '额度管控', value: creditControlType?.creditControlType1 || 0 },
      { name: '账期管控', value: creditControlType?.creditControlType2 || 0 }
    ]
  })

  request.post<AxiosResult, AxiosResult>('/fbu/api/report/risk/fixedLimitRuleType', formState.value).then((res) => {
    const { fixedLimitRuleType } = res.data
    fixedLimitRuleTypeList.value = [
      { name: '申请金额-转运客户', value: fixedLimitRuleType?.transportQuota || 0 },
      { name: '申请金额-仓储新客', value: fixedLimitRuleType?.newStorageQuota || 0 },
      { name: '申请金额-仓储老客', value: fixedLimitRuleType?.oldStorageQuota || 0 },
      { name: '申请系数-标准系数', value: fixedLimitRuleType?.standardCoeff || 0 },
      { name: '申请系数-非标准系数', value: fixedLimitRuleType?.nonStandardCoeff || 0 }
    ]
  })

  fetchOverdue()
  fetchCredit()
}

const overdueRef = ref({
  dateQueryType: 3,
  dataType: 1
})

const yearOverdue = ref<Dayjs>(dayjs())
const weakOverdue = ref<[Dayjs, Dayjs]>([dayjs().startOf('week').add(-13, 'week'), dayjs().startOf('week')])
const dayOverdue = ref<Dayjs>(dayjs().startOf('month'))
const overdueList = ref([])
const fetchOverdue = () => {
  const p = {}
  p.employeeNo = formState.value.employeeNo
  p.dataPermissionQueryType = formState.value.dataPermissionQueryType
  p.dateQueryType = overdueRef.value.dateQueryType

  if (p.dateQueryType === 3) {
    p.startMonth = dayjs(yearOverdue.value).format('YYYY01')
    p.endMonth = dayjs(yearOverdue.value).format('YYYY12')
  } else if (p.dateQueryType === 2) {
    p.startWeek = dayjs(weakOverdue.value[0]).format('YYYYww')
    p.endWeek = dayjs(weakOverdue.value[1]).format('YYYYww')
  } else {
    p.startDay = dayjs(dayOverdue.value.startOf('month')).format('YYYY/MM/DD')
    p.endDay = dayjs(dayOverdue.value.endOf('month')).format('YYYY/MM/DD')
  }
  request.post<AxiosResult, AxiosResult>('/fbu/api/report/risk/overdueRateList', p).then((res) => {
    overdueList.value = generateOverdueList(p, res.data?.overdueList || [])
  })
}
const generateOverdueTips = (item: any) => {
  return overdueRef.value.dataType === 1 ? `逾期率 <span style="font-weight: bolder;font-size: 16px">${(item?.overdueRate || '0%')}</span>` : `逾期金额 <span style="font-weight: bolder;font-size: 16px">${item?.overdueAmount || 0}</span>`
}
const generateOverdueList = (p: any, list: any) => {
  const datas = []
  if (p.dateQueryType === 3) {
    const year = dayjs(yearOverdue.value).startOf('month').format('YYYY')
    for (let i = 1; i <= 12; i++) {
      const item = list.find((ii: any) => ii.monthValue % 100 === i)
      const value = overdueRef.value.dataType === 1 ? convertPercentageToNumber(item?.overdueRate) : item?.overdueAmount || 0
      datas.push({
        name: `${i}`,
        value: value,
        tooltip: `${year}/${String(i).padStart(
          2,
          '0'
        )}<br>${generateOverdueTips(item)}`
      })
    }
  } else if (p.dateQueryType === 2) {
    let currentDay = dayjs(weakOverdue.value[0])
    const lastDay = dayjs(weakOverdue.value[1])

    while (currentDay.isBefore(lastDay.endOf('day')) || currentDay.isSame(lastDay.endOf('day'), 'day')) {
      const item = list.find((ii: any) => ii.weekValue === parseInt(currentDay.format('YYYYww')))
      // const quantity = item?.quantity || 0
      // const total = item?.total || 0
      const value = overdueRef.value.dataType === 1 ? convertPercentageToNumber(item?.overdueRate) : item?.overdueAmount || 0
      datas.push({
        name: currentDay.format('YYYY-wo'),
        value: value,
        tooltip: `${currentDay.startOf('week').format('YYYY/MM/DD')}-${currentDay
          .endOf('week')
          .format(
            'YYYY/MM/DD'
          )}<br>${generateOverdueTips(item)}`
      })
      currentDay = currentDay.add(1, 'week')
    }
  } else {
    let currentDay = dayjs(dayOverdue.value.startOf('month'))
    const lastDay = dayjs(dayOverdue.value.endOf('month'))

    while (currentDay.isBefore(lastDay) || currentDay.isSame(lastDay, 'day')) {
      const item = list.find((ii: any) => ii.dayValue === currentDay.format('YYYY/MM/DD'))
      // const quantity = item?.quantity || 0
      // const total = item?.total || 0
      const value = overdueRef.value.dataType === 1 ? convertPercentageToNumber(item?.overdueRate) : item?.overdueAmount || 0
      datas.push({
        name: currentDay.format('YYYY/MM/DD'),
        value: value,
        tooltip: `${currentDay.format('YYYY/MM/DD')}
          <br>${generateOverdueTips(item)}`
      })
      currentDay = currentDay.add(1, 'day')
    }
  }

  return datas
}

const creditRef = ref({
  dateQueryType: 3,
  dataType: 0
})
const yearCredit = ref<Dayjs>(dayjs())
const weakCredit = ref<[Dayjs, Dayjs]>([dayjs().startOf('week').add(-13, 'week'), dayjs().startOf('week')])
const dayCredit = ref<Dayjs>(dayjs().startOf('month'))
const creditList = ref([])

const fetchCredit = () => {
  const p = {}
  p.employeeNo = formState.value.employeeNo
  p.dataPermissionQueryType = formState.value.dataPermissionQueryType
  p.dateQueryType = creditRef.value.dateQueryType

  if (p.dateQueryType === 3) {
    p.startMonth = dayjs(yearCredit.value).format('YYYY01')
    p.endMonth = dayjs(yearCredit.value).format('YYYY12')
  } else if (p.dateQueryType === 2) {
    p.startWeek = dayjs(weakCredit.value[0]).format('YYYYww')
    p.endWeek = dayjs(weakCredit.value[1]).format('YYYYww')
  } else {
    p.startDay = dayjs(dayCredit.value.startOf('month')).format('YYYY/MM/DD')
    p.endDay = dayjs(dayCredit.value.endOf('month')).format('YYYY/MM/DD')
  }
  request.post<AxiosResult, AxiosResult>(creditRef.value.dataType === 1 ? '/fbu/api/report/risk/usedQuotaRateList' : '/fbu/api/report/risk/creditCoefficientList', p).then((res) => {
    creditList.value = generateCreditList(p, res.data?.creditCoefficientList || res.data?.usedQuotaRateList || [])
  })
}

const generateCreditTips = (item: any) => {
  return creditRef.value.dataType === 1 ? `已使用固定额度占比 <span style="font-weight: bolder;font-size: 16px">${(item?.usedQuotaRate || '0%')}</span>` : `实际授信系数 <span style="font-weight: bolder;font-size: 16px">${item?.creditCoefficient || '0'}</span>`
}
const generateCreditList = (p: any, list: any) => {
  const datas = []
  if (p.dateQueryType === 3) {
    const year = dayjs(yearCredit.value).startOf('month').format('YYYY')
    for (let i = 1; i <= 12; i++) {
      const item = list.find((ii: any) => ii.monthValue % 100 === i)
      const value = creditRef.value.dataType === 0 ? (item?.creditCoefficient || 0) : convertPercentageToNumber(item?.usedQuotaRate)
      datas.push({
        name: `${i}`,
        value: value,
        tooltip: `${year}/${String(i).padStart(
          2,
          '0'
        )}<br>${generateCreditTips(item)}`
      })
    }
  } else if (p.dateQueryType === 2) {
    let currentDay = dayjs(weakOverdue.value[0])
    const lastDay = dayjs(weakOverdue.value[1])

    while (currentDay.isBefore(lastDay.endOf('day')) || currentDay.isSame(lastDay.endOf('day'), 'day')) {
      const item = list.find((ii: any) => ii.weekValue === parseInt(currentDay.format('YYYYww')))
      // const quantity = item?.quantity || 0
      // const total = item?.total || 0
      const value = creditRef.value.dataType === 0 ? (item?.creditCoefficient || 0) : convertPercentageToNumber(item?.usedQuotaRate)
      datas.push({
        name: currentDay.format('YYYY-wo'),
        value: value,
        tooltip: `${currentDay.startOf('week').format('YYYY/MM/DD')}-${currentDay
          .endOf('week')
          .format(
            'YYYY/MM/DD'
          )}<br>${generateCreditTips(item)}`
      })
      currentDay = currentDay.add(1, 'week')
    }
  } else {
    let currentDay = dayjs(dayOverdue.value.startOf('month'))
    const lastDay = dayjs(dayOverdue.value.endOf('month'))

    while (currentDay.isBefore(lastDay) || currentDay.isSame(lastDay, 'day')) {
      const item = list.find((ii: any) => ii.dayValue === currentDay.format('YYYY/MM/DD'))
      // const quantity = item?.quantity || 0
      // const total = item?.total || 0
      const value = creditRef.value.dataType === 0 ? (item?.creditCoefficient || 0) : convertPercentageToNumber(item?.usedQuotaRate)
      datas.push({
        name: currentDay.format('YYYY/MM/DD'),
        value: value,
        tooltip: `${currentDay.format('YYYY/MM/DD')}
          <br>${generateCreditTips(item)}`
      })
      currentDay = currentDay.add(1, 'day')
    }
  }

  return datas
}

function convertPercentageToNumber(percentageString: string): number {
  if (!percentageString) {
    return 0
  }
  const noPercentage = percentageString.replace(/%/, '').replaceAll(',', '')
  return Number(noPercentage) / 100
}

import riseImage from '@/assets/rise.png';
import declineImage from '@/assets/decline.png';
const imageByCompare = (num1: number, num2: number) => {
  if (num1 > num2) {
    return '<img src="' + riseImage + '" class="icon icon-right" alt="" />'
  } else if (num1 < num2) {
    return '<img src="' + declineImage + '" class="icon icon-right" alt="" />'
  } else {
    return ''
  }
}

onMounted(() => {
  fetchData()
})


</script>
<style lang="scss" scoped>
@import './index.scss';

.padding-bg {
  padding: 16px;
}
</style>